module.exports = __webpack_public_path__ + "static/media/video-img.757ea9fe.png";